import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { NeighborhoodFragment } from '@api/fragments'
import { INeighborhood } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  addEmployeesToNeighborhood: {
    neighborhood: INeighborhood
  }
}

const mutation = gql`
  mutation UpdateEmployeeNeighborhoods($input: AddEmployeesToNeighborhoodInput!) {
    addEmployeesToNeighborhood(input: $input) {
      neighborhood {
        ...NeighborhoodFragment
      }
    }
  }
  ${NeighborhoodFragment}
`

const mutateHandler = handleFetchResult<IPayload, INeighborhood>({
  handler: (data) => data.addEmployeesToNeighborhood.neighborhood,
  name: 'Neighborhood Employees',
})

export default function addEmployeesToNeighborhood(
  neighborhoodId: string,
  employeeIds: string[]
): Promise<INeighborhood> {
  const input = { neighborhoodId, employeeIds }

  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}
